var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'meus-dados' }}},[_c('img',{staticClass:"logo",style:({ filter: _vm.fillColor }),attrs:{"id":"estrategia-logo","src":_vm.logo,"alt":"Estratégia"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }